import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Row } from 'reactstrap';
import isEmpty from 'lodash/isEmpty';

import HitCard from 'Components/Cards/HitCard';
import PriceContainer from 'Containers/Utility/Price/PriceContainer';
import { fetchRecentlyViewed as fetchRecentlyViewedAction } from 'Redux/ducks/recently-viewed';
import SkeletonHitCard from 'Components/Cards/SkeletonHitCard';

const RecentlyViewedContainer = ({
  recentlyViewedHits,
  xsSize,
  smSize,
  mdSize,
  lgSize,
  fetchRecentlyViewed,
  hitsToDisplay,
  fetchHits,
  pathname,
}) => {
  useEffect(() => {
    if (fetchHits) {
      fetchRecentlyViewed(hitsToDisplay);
    }
  }, [fetchHits, fetchRecentlyViewed, hitsToDisplay]);

  let cardLgSize = lgSize;

  if (pathname === '/recently-viewed') {
    cardLgSize = 4;
  }

  return (
    <div className="container">
      <Row className="recommendation-container">
        {isEmpty(recentlyViewedHits) &&
          <SkeletonHitCard
            numberOfCards={hitsToDisplay}
            lgSize={cardLgSize}
            mdSize={mdSize}
            smSize={smSize}
            xsSize={xsSize}
          />
        }
        {recentlyViewedHits && recentlyViewedHits.slice(0, hitsToDisplay).map(hit =>
          <HitCard
            key={hit.objectID}
            hit={hit}
            xsSize={xsSize}
            smSize={smSize}
            mdSize={mdSize}
            lgSize={cardLgSize}
          >
            <PriceContainer
              discountPercent={hit.discount_percent}
              price={hit.price}
              tiered={hit.tiered}
              slug={hit.slug}
              hideDiscount={hit.hide_discount}
              payWhatYouWant={hit.pay_what_you_want}
            />
          </HitCard>,
        )}
      </Row>
    </div>
  );
};

RecentlyViewedContainer.propTypes = {
  recentlyViewedHits: PropTypes.arrayOf(PropTypes.shape({})),
  xsSize: PropTypes.number,
  smSize: PropTypes.number,
  mdSize: PropTypes.number,
  lgSize: PropTypes.number,
  fetchRecentlyViewed: PropTypes.func.isRequired,
  hitsToDisplay: PropTypes.number,
  fetchHits: PropTypes.bool,
  pathname: PropTypes.string,
};

RecentlyViewedContainer.defaultProps = {
  recentlyViewedHits: [],
  xsSize: 6,
  smSize: 6,
  mdSize: 4,
  lgSize: 3,
  hitsToDisplay: 4,
  fetchHits: true,
  pathname: '',
};

const mapStateToProps = ({
  recentlyViewed: { recentlyViewedHits },
  router: { location },
}) => ({
  recentlyViewedHits,
  pathname: location.pathname,
});

const mapDispatchToProps = {
  fetchRecentlyViewed: fetchRecentlyViewedAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(RecentlyViewedContainer);
